<template>
  <div id="app">
    <el-container>
      <el-header class="flex flex-mid" direction="horizontal">
        <i style="font-size: 36px;color: #409EFF;">智能电表</i>
        <div class="flex-1"></div>

        <head-image size="40" radius="50%"></head-image>
        <div class="ml-20">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
               <!--{{$store.state.LoginUser.userType == 0?'用户':'管理员'}}：-->
              <!--{{$store.state.LoginUser.passport}}-->
              {{$store.state.LoginUser.type==1?"超级管理员":$store.state.LoginUser.name}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <!--<el-dropdown-item @click.native="showModel">修改密码</el-dropdown-item>-->
              <el-dropdown-item @click.native="logout">退出登陆</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-container>
        <el-aside width="265px">
          <el-col :span="24">
            <el-menu
              :default-active="$store.state.currentPath"
              class="el-menu-vertical-demo"
              :unique-opened="true"
              background-color="#545c64"
              text-color="#fff"
              :router="true"
            >
              <el-submenu v-if="$store.state.LoginUser.type==2" index="1">
                <template slot="title">

                  <span>用电记录</span>
                </template>
                <el-menu-item index="/admin/electric/1">日用电</el-menu-item>
                <el-menu-item index="/admin/electric/2">月用电</el-menu-item>
              </el-submenu>
              <el-menu-item v-if="$store.state.LoginUser.type==2" index="/admin/recharge">充值记录</el-menu-item>
              <el-menu-item v-if="$store.state.LoginUser.type==2" index="/admin/task">监控列表</el-menu-item>
              <el-menu-item v-if="$store.state.LoginUser.type==2" index="/admin/users">用户列表</el-menu-item>
              <el-menu-item v-if="$store.state.LoginUser.type==2" index="/admin/price">电价列表</el-menu-item>
              <el-menu-item  index="/admin/con">集中器列表</el-menu-item>
              <el-menu-item v-if="$store.state.LoginUser.type==1" index="/superAdmin/company">公司管理</el-menu-item>
              <el-menu-item v-if="$store.state.LoginUser.type==1" index="/superAdmin/meterProtocol">监控协议管理</el-menu-item>
              <el-menu-item index="/superAdmin/Message">消息提醒</el-menu-item>
              <el-menu-item index="/admin/downloadTask">下载任务</el-menu-item>
            </el-menu>
          </el-col>
        </el-aside>
        <div class="smart-main">
          <el-main>
            <router-view/>
          </el-main>
        </div>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  import HeadImage from "../../components/HeadImage";
  import Message from "../../components/Message";
  import FormDialog from "../../components/FormDialog";
  export default {
    components: {
      FormDialog,
      Message,
      HeadImage
    },
    name: 'App',
    data(){
      return {
        form: {},
        dept: {},
        emp: {}
      }
    },
    beforeMount(){
      let login = this.$checkLogin()
      this.$store.commit('setLoginUser', login)
    },
    mounted(){
      this.$store.commit('setCurrentPath', this.$route.path)
//      this.getDeptTree()
    },
    methods: {
      logout(){
//        this.$http$({methods: 'post', url: '/webServer/logout'}, (data) => {
          this.$setCookie('METER_LOGIN_USER', '', -1)
          window.location.href = 'login.html'
//        })
      },
      showModel(){
        this.$refs.model.show()
      },
      hideModel(){
        this.$refs.model.hide()
      },
      editPassword(){
        this.form.accountId = this.$store.state.LoginUser.accountId
        this.$http$({method: 'put', url: '/webServer/account/changePassword', data: this.form}, () => {
          this.$success('修改密码成功！')
          this.hideModel()
        })
      },
      getAllEmployee(id){
        this.$http$({method: 'get', url: '/webServer/department/allChild', data: {departmentId: id}}, (data) => {
          this.$mapList(data, this.setEmp)
        })
      },
      getDeptTree(){
        this.$http$({method: 'get', url: '/webServer/department/tree'}, (data) => {
          this.$mapTree(data, 'departments',this.setDept)
          this.getAllEmployee(data.id)
        })
      },
      setEmp(id, name){
        this.emp[id] = name
        this.$store.commit('saveEmployee', this.emp)
      },
      setDept(id, name){
        this.dept[id] = name
        this.$store.commit('saveDepartment', this.dept)
      }
    }
  }
</script>

<style>
  .el-submenu__title i {
    color: #fff
  }

  .el-header {
    background: #333;
    color: #fff;
    position: absolute;
    width: 100%;
    height: 60px;
    left: 0;
    top: 0;
    min-width: 1450px;
  }

  .el-aside {
    position: absolute;
    top: 60px;
    left: 0px;
    width: 265px;
    bottom: 0px;
    background: rgb(84, 92, 100);
    overflow-y: scroll;
  }

  .el-menu {
    border-right: none;
  }

  .el-dropdown-menu {
    min-width: 100px;
  }

  .smart-main {
    position: absolute;
    top: 60px;
    left: 250px;
    right: 0px;
    bottom: 0px;
    background: #fff;
    z-index: auto;
    overflow-y: auto;
    min-width: 1200px;

  }

  .el-dropdown {
    height: 50px;
    line-height: 50px;
    color: #fff;
  }
  .footer{
    font-size: 12px;
    position: fixed;
    left: 0;
    height: 25px;
    right: 0;
    bottom: 0;
    background: #333;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/entrance/index/AdminIndex.vue